import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { Transaction } from "../../../../models/data/blobby/transaction.data";
import { TransactionResponse } from "../../../../models/data/response/transaction-response";
import {
  transaction_v0_to_v1,
  transaction_v1_to_v2,
  transaction_v2_to_v3,
  transaction_v3_to_v4,
  transaction_v4_to_v5,
  transaction_v5_to_v6,
  transaction_v6_to_v7,
  transaction_v7_to_v8,
  transaction_v8_to_v9,
} from "../model-dto/transaction";
import { TransactionStoreModel } from "@bitwarden/web-vault/app/models/store/transaction.store.model";

export class TransactionParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported VaultFile parser version ${version}`);
    }

    if (version === 0) {
      return TransactionParser_v0;
    }

    if (version === 1) {
      return TransactionParser_v1;
    }

    if (version === 2) {
      return TransactionParser_v2;
    }

    if (version === 3) {
      return TransactionParser_v3;
    }

    if (version === 4) {
      return TransactionParser_v4;
    }

    if (version === 5) {
      return TransactionParser_v5;
    }

    if (version === 6) {
      return TransactionParser_v6;
    }

    if (version === 7) {
      return TransactionParser_v7;
    }

    if (version === 8) {
      return TransactionParser_v8;
    }

    return TransactionParser_v9;
  }

  override getSupportedVersion(): number[] {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  }
}

const TransactionParser_v9 = (transactionModel: any): TransactionStoreModel =>
  transactionModel as TransactionStoreModel;

const TransactionParser_v8 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v8_to_v9(transactionModel);
  return TransactionParser_v9(upgraded);
};

const TransactionParser_v7 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v7_to_v8(transactionModel);
  return TransactionParser_v8(upgraded);
};

const TransactionParser_v6 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v6_to_v7(transactionModel);
  return TransactionParser_v7(upgraded);
};

const TransactionParser_v5 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v5_to_v6(transactionModel);
  return TransactionParser_v6(upgraded);
};

const TransactionParser_v4 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v4_to_v5(transactionModel);
  return TransactionParser_v5(upgraded);
};

const TransactionParser_v3 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v3_to_v4(transactionModel);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = transactionModel.vid ?? "";
  return TransactionParser_v4(upgraded);
};

const TransactionParser_v2 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v2_to_v3(transactionModel);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = transactionModel.vid ?? "";
  return TransactionParser_v3(upgraded);
};

const TransactionParser_v1 = (transactionModel: any): TransactionStoreModel => {
  const upgraded = transaction_v1_to_v2(transactionModel);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = transactionModel.vid ?? "";
  return TransactionParser_v2(upgraded);
};

const TransactionParser_v0 = (transactionModel: any): TransactionStoreModel => {
  const response = new TransactionResponse(transactionModel);
  const transaction = new Transaction(response);
  const upgraded = transaction_v0_to_v1(transaction);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = transactionModel.vid ?? "";
  return TransactionParser_v1(upgraded);
};
